import React, { useState, useMemo } from 'react'
import './ClientsTable.css'
import ReactPaginate from 'react-paginate';
import { GrFormPrevious } from "react-icons/gr";
import { MdNavigateNext } from "react-icons/md";
import ColumnSearch from './ColumnSearch';

function ClientsTable({ clientData, mapStatistic, regionHighlighted, clientTableExpand }) {
    // //console.log(clientData)
    const itemsPerPage = 20;
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [search, setSearch] = useState(null)
    const [searchColumn, setSearchColumn] = useState('')
    const currentItems = clientData?.slice(indexOfFirstItem, indexOfLastItem);

    const [sorting, setSorting] = useState({
        column: "master.client_name",
        order: "asc",
    });

    const tableData = useMemo(() => {
        if (sorting?.order == "asc") {
            return clientData?.sort((a, b) => {
                return a[sorting?.column]?.localeCompare(b[sorting?.column]);
            });
        } else {

            return clientData?.sort((a, b) => {
                return b[sorting?.column]?.localeCompare(a[sorting?.column]);
            });
        }
        //  setTableData(data1)


    }, [clientData, sorting?.column, sorting?.order, clientTableExpand]);


    const totalPages = Math.ceil(
        (tableData
            ?.filter(data => {
                if (clientTableExpand?.stage === 'prospects' && data['master.status'] === 'POTENTIAL') {
                    return data
                } else if (clientTableExpand?.stage === 'onboard' && (data['master.status'] === 'ACTIVE' || data['master.status'] === 'INACTIVE')) {
                    return data
                } else if (clientTableExpand?.stage === 'active' && data['master.status'] === 'ACTIVE') {
                    return data
                }
                else if (clientTableExpand?.stage === 'inactive' && data['master.status'] === 'INACTIVE') {
                    return data
                }
            })?.filter(data => {
                // //console.log(data?.stateCode,data['master.district'],regionHighlighted?.stateCode)
                if (clientTableExpand?.state === 'TT') {
                    return data
                }
                if (data?.stateCode === clientTableExpand?.state) {
                    // //console.log(data)
                    return data
                }
            })
            ?.filter(data => {
                if (clientTableExpand?.district) {
                    if (data['master.district']?.toString()?.toLowerCase() === clientTableExpand?.district?.toString()?.toLowerCase()) {
                        return data
                    }
                } else {
                    return data
                }
            })
            .length || 0) / itemsPerPage
    );



    return (
        <div className='client-table'>

            <div className='client-table-head'>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (
                            sorting?.column === "master.client_name" &&
                            sorting?.order === "asc"
                        ) {
                            setSorting({
                                column: "master.client_name",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "master.client_name",
                                order: "asc",
                            });
                        }
                    }}
                >
                    <div>Client Name</div>
                    <div>

                        {sorting?.column === "master.client_name" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                        <ColumnSearch className={'client-seacrh'} setSearch={setSearch} setSearchColumn={setSearchColumn} column={'master.client_name'} />
                    </div>

                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (
                            sorting?.column === "master.address" &&
                            sorting?.order === "asc"
                        ) {
                            setSorting({
                                column: "master.address",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "master.address",
                                order: "asc",
                            });
                        }
                    }}
                > <div>Address</div>
                    <div>

                        {sorting?.column === "master.address" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                        <ColumnSearch setSearch={setSearch} setSearchColumn={setSearchColumn} column={'master.address'} />
                    </div>
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (
                            sorting?.column === "master.district" &&
                            sorting?.order === "asc"
                        ) {
                            setSorting({
                                column: "master.district",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "master.district",
                                order: "asc",
                            });
                        }
                    }}
                > <div>City</div>
                    <div>

                        {sorting?.column === "master.district" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                        <ColumnSearch setSearch={setSearch} setSearchColumn={setSearchColumn} column={'master.district'} />
                    </div>
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (
                            sorting?.column === "master.state" &&
                            sorting?.order === "asc"
                        ) {
                            setSorting({
                                column: "master.state",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "master.state",
                                order: "asc",
                            });
                        }
                    }}
                > <div>State</div>

                    <div>

                        {sorting?.column === "master.state" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                        <ColumnSearch setSearch={setSearch} setSearchColumn={setSearchColumn} column={'master.state'} />
                    </div>
                </div>
            </div>

            <div className='client-table-body'>
                {tableData?.filter(data => {
                    if (clientTableExpand?.stage === 'prospects' && data['master.status'] === 'POTENTIAL') {
                        return data
                    } else if (clientTableExpand?.stage === 'onboard' && (data['master.status'] === 'ACTIVE' || data['master.status'] === 'INACTIVE')) {
                        return data
                    } else if (clientTableExpand?.stage === 'active' && data['master.status'] === 'ACTIVE') {
                        return data
                    }
                    else if (clientTableExpand?.stage === 'inactive' && data['master.status'] === 'INACTIVE') {
                        return data
                    }

                })?.filter(data => {
                    // //console.log(data?.stateCode,data['master.district'],regionHighlighted?.stateCode)
                    if (clientTableExpand?.state === 'TT') {
                        return data
                    }
                    if (data?.stateCode === clientTableExpand?.state) {
                        // //console.log(data)
                        return data
                    }
                })
                    ?.filter(data => {
                        if (clientTableExpand?.district) {
                            if (data['master.district']?.toString()?.toLowerCase() === clientTableExpand?.district?.toString()?.toLowerCase()) {
                                return data
                            }
                        } else {
                            return data
                        }
                    })?.filter(data => {
                        if (search === null || search === '') {
                            return data
                        } else {
                            if (data[searchColumn]?.toString()?.toLowerCase()?.includes(search?.toString()?.toLowerCase())) {
                                return data
                            }
                        }
                    })

                    ?.slice(indexOfFirstItem, indexOfLastItem)?.map((data, id) => (
                        <div>
                            <div>{data['master.client_name']}</div>
                            <div>{data['master.address']}</div>
                            <div>{data['master.district']}</div>
                            <div>{data['master.state']}</div>
                        </div>
                    ))
                }

            </div>

            <div className='pagination' style={{ float: "right", marginRight: "20px", marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                <GrFormPrevious style={{ cursor: 'pointer' }}
                    disabled={currentPage === 1}
                    onClick={() => {
                        if (currentPage === 1) {
                            return
                        }
                        setCurrentPage(currentPage - 1)
                    }}
                >
                    Previous
                </GrFormPrevious>
                <span>{`${currentPage} of ${totalPages}`}</span>
                <MdNavigateNext style={{ cursor: 'pointer' }}
                    disabled={currentPage === totalPages}


                    onClick={() => {
                        if (currentPage === totalPages) {
                            return
                        }
                        setCurrentPage(currentPage + 1)

                    }}
                >
                    Next
                </MdNavigateNext>
            </div>

        </div>
    )
}

export default ClientsTable
